module.exports = __webpack_public_path__ + "img/demo-pet-supplies-600x450.257678b7.jpg";